import React from 'react'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import { Link } from 'react-router-dom'

const Title = styled(Typography)`
  font-size: 24px;
  & a {
    color: #fff;
    text-decoration: none;
  }
`
const Main = styled.main`
  margin: 0 auto;
  padding: 0 16px;
  margin-top: 24px;
  max-width: 1200px;
`
const PageTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 24px;
  color: #333;
`

interface Layout {
  title?: string
}

export const LayoutContainer: React.FC<Layout> = (props) => {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Title variant="h1"><Link to="/">Abema Survey</Link></Title>
        </Toolbar>
      </AppBar>
      <Main>
        {props.title && <PageTitle>{props.title}</PageTitle>}
        {props.children}
      </Main>
    </>
  );
}

  export default LayoutContainer
